/**
 * StopIcon/index.js
 * desc: content stop icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const StopIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="stop icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.stop.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M83.668 17V67C83.668 76.1914 76.1914 83.668 67 83.668H17C7.80863 83.668 0.332031 76.1914 0.332031 67V17C0.332031 7.80863 7.80863 0.332031 17 0.332031H67C76.1914 0.332031 83.668 7.80863 83.668 17Z"/>
        </svg>
    </IconButton>
);


export default StopIcon;
